import React from 'react'
import { connect } from 'react-redux'
import { StyleSheet, Platform } from 'react-native'
import OverlayWeb from './web/Overlay';
import Portal from './web/portal';
import Spinner from './spiner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Overlayer = Platform.OS === 'web' ? OverlayWeb : Overlay;

class Component extends React.Component {
    render () {
        const { loading } = this.props;

        return [
            <Portal key={1}>
                <Overlayer 
                    key='overlay'
                    isVisible={loading}
                    windowBackgroundColor="rgba(0, 0, 0, .5)"
                    overlayBackgroundColor="#ffffff">
                        {loading ? <Spinner /> : null}
                </Overlayer>
            </Portal>,
            <Portal key={2}>
                <ToastContainer 
                    autoClose={5000}
                    style={{
                        zIndex: 10000,
                    }} />
            </Portal>,
        ]
    }
}

const mapStateToProps = state => {
    return {
        loading: state.app.loading,
        toast: `state.app.toast`,
    };
};
 
  
export default connect(mapStateToProps)(Component);


const styles = StyleSheet.create({
    toaster: {
        backgroundColor: 'red',
        position: 'fixed',
        bottom: 10,
    },
    main: {
        flex: 0,
    }
});
